module.exports = __webpack_public_path__ + "static/media/shape_V.2dd130df.glb";